import { useEffect } from 'react'
import styles from './AuthLayout.module.scss'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ROUTES } from '../../../router/routes'
import NavBar from '../../NavBar/NavBar'
import { CanvasPolling } from './components/Poolers/CanvasPolling'
import { useUserInfo } from '../../../api/hooks/user/useUserInfo'
import { useWorkspaces } from '../../../api/hooks/workspaces/useWorkspaces'
import { switchWorkspace } from '../../../store/actions/authActions'
import { ModalProvider, ModalOutlet } from '../../modals/'

export const AuthLayout = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated)
    const isDemoUser = useSelector((state) => state.auth.isDemoUser)
    const isEmbeddedUser = useSelector((state) => state.auth.isEmbeddedUser)
    const workspaceName = useSelector((state) => state.auth.workspaceName)
    const { user } = useUserInfo()
    const { workspaces } = useWorkspaces()

    const queryParams = new URLSearchParams(window.location.search)
    const inviteCode = queryParams.get('invite')

    useEffect(() => {
        if (user?.defaultWorkspace && workspaces?.length > 0) {
            const defaultWorkspaceID = user?.defaultWorkspace
            const defaultWorkspace = workspaces?.find(
                (workspace) => workspace.workspaceID === defaultWorkspaceID
            )
            if (defaultWorkspace)
                dispatch(switchWorkspace(defaultWorkspace?.workspaceID, defaultWorkspace?.name))
        }
    }, [user, workspaces])

    // Demo users should only access demo chat, redirect them back
    if (isDemoUser) {
        return <Navigate to={ROUTES.DEMO_CHAT} />
    }

    // Embedded users should only access embedded chat, redirect them back
    if (isEmbeddedUser) {
        return <Navigate to={ROUTES.EMBEDDED_CHAT} />
    }

    // Redirect to the logout route if the forceLogin query parameter is present
    const forceLogin = queryParams.get('forceLogin')
    if (forceLogin) {
        localStorage.setItem('forceLogin', forceLogin)
        return <Navigate to={ROUTES.LOGOUT} />
    }

    // Redirect to the logout route if the filledLogin query parameter is present (when user fills out form on our site or airtable etc)
    const filledLogin = queryParams.get('filledLogin')
    if (filledLogin) {
        localStorage.setItem('filledLogin', filledLogin)
        return <Navigate to={ROUTES.LOGOUT} />
    }

    if (location.pathname === '/' && (isAuthenticated || inviteCode)) {
        return <Navigate to={ROUTES.INSIGHTS} />
    }

    return isAuthenticated || inviteCode ? (
        <ModalProvider>
            <div className={styles.appContainer}>
                <CanvasPolling />
                <NavBar workspaceName={workspaceName} />
                <Outlet />
            </div>
            <ModalOutlet />
        </ModalProvider>
    ) : (
        <Navigate to={ROUTES.LOGIN} />
    )
}
